import { render, staticRenderFns } from "./luoxuan.vue?vue&type=template&id=ccb8a996&scoped=true&"
import script from "./luoxuan.vue?vue&type=script&lang=js&"
export * from "./luoxuan.vue?vue&type=script&lang=js&"
import style0 from "./luoxuan.vue?vue&type=style&index=0&id=ccb8a996&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb8a996",
  null
  
)

export default component.exports